import { useAuth } from '@clerk/clerk-react'
import { useQuery } from '@tanstack/react-query'
import { apiFetch } from './api'

export type Role = 'admin' | 'clevel' | 'user'

export type Me = {
  id: string
  email: string
  role: Role
}

export function useMe() {
  const { getToken, isSignedIn } = useAuth()
  return useQuery({
    queryKey: ['me'],
    enabled: !!isSignedIn,
    queryFn: () => apiFetch<Me>('/auth/me', () => getToken()),
  })
}
